import React from "react";
import Layout from "@/components/layout/Layout";

export function Privacy() {
  return (
    <Layout>
      <section className="py-28 max-w-3xl mx-auto px-6">
        <span className="eyebrow">Legal</span>
        <h1 className="heading-section mt-3">Privacy Policy</h1>
        <div className="mt-10 space-y-5 text-tratou-dim leading-relaxed">
          <p>Tratou Energy ("we") respects the privacy of every visitor and customer. We collect only the data required to deliver, support and improve our Mobile Battery Energy Storage Systems (MBESS) and Energy-as-a-Service offerings.</p>
          <p><span className="text-white">Data we collect.</span> Contact information you submit through our forms (name, company, email, phone, project details). Site analytics (anonymised, aggregated). MBESS telemetry from deployed units (battery state, location).</p>
          <p><span className="text-white">How we use it.</span> To respond to your enquiry, prepare a tailored proposal, deliver our services, comply with regulations, and improve product reliability.</p>
          <p><span className="text-white">Your rights.</span> Access, rectification, deletion, portability. Contact <a className="text-tratou-green" href="mailto:info@tratouenergy.com">info@tratouenergy.com</a>.</p>
          <p>This policy may be updated; the latest version is always published on this page.</p>
        </div>
      </section>
    </Layout>
  );
}

export function Terms() {
  return (
    <Layout>
      <section className="py-28 max-w-3xl mx-auto px-6">
        <span className="eyebrow">Legal</span>
        <h1 className="heading-section mt-3">Terms of Service</h1>
        <div className="mt-10 space-y-5 text-tratou-dim leading-relaxed">
          <p>By accessing tratouenergy.com you agree to these terms. Service-specific agreements (EaaS contracts, MBESS supply contracts) supersede these terms where applicable.</p>
          <p><span className="text-white">Use of the website.</span> The site and its content are provided for informational purposes. No commercial offer arises until a signed contract is in place.</p>
          <p><span className="text-white">Intellectual property.</span> All trademarks, copy, designs and code on this site are owned by Tratou Energy or its licensors.</p>
          <p><span className="text-white">Liability.</span> To the maximum extent permitted by law, Tratou Energy disclaims liability for indirect or consequential damages arising from website use.</p>
          <p>Governing law: United Arab Emirates.</p>
        </div>
      </section>
    </Layout>
  );
}
